<script>
	import Modal from "./Modal.svelte"
	export let title, nameImg, alt, description
	
</script>

<div class="Card">
	<picture class="Card--img">
		<source media="(prefers-color-scheme: dark)" srcset="./img/darks/{nameImg}" {alt} class="Card--img__item">
		<img src="./img/{nameImg}" {alt} class="Card--img__item">
	</picture>
	<h3 class="Card--title">
		{title}
	</h3>
	<p class="Card--paragrah">
		{description}
	</p>
	<slot />
</div>

<style>
	.Card{
		background-color: var(--secundary);
		text-align: center;
		border-radius: 5px;
		padding: 0 2rem 1.5rem;
		flex: 1 1 250px;
		display: grid;
		grid-template-rows: auto auto 1fr;
	}
	.Card--img{
		display: block;
	}
	.Card--img__item{
		min-height: 30%;
		margin: -1rem auto 2.5rem;
		max-width: 95%;
	}
	.Card--title{
		margin-bottom: 1.5rem;
		font-weight: 900;
	}
	.Card--paragrah{
		display: flex;
		align-items: center;
		margin-bottom: 1rem;
	}
</style>